import * as React from "react";

import { useState } from "react";
import { useLocation } from "react-router-dom";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Fab from "@mui/material/Fab";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CloseIcon from "@mui/icons-material/Close";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import Header from "./Header";
import ManualContent from "./help/ManualContent";

export default function PageAwareManual({
  open = true,
  color,
  text = "Page Manual",
  variant = "menu",
  fabSx,
}) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  if (location.pathname === "/info/manual") {
    return null;
  }

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      {variant === "fab" ? (
        <Fab
          color="secondary"
          size="medium"
          onClick={handleOpen}
          aria-label={text}
          sx={fabSx}
        >
          <HelpOutlineIcon />
        </Fab>
      ) : (
        <ListItem disablePadding sx={{ display: "block" }}>
          <ListItemButton
            onClick={handleOpen}
            sx={{
              minHeight: 48,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 3 : "auto",
                justifyContent: "center",
                color: "action.active",
              }}
            >
              <HelpOutlineIcon />
            </ListItemIcon>
            <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
          </ListItemButton>
        </ListItem>
      )}

      <Drawer
        anchor="bottom"
        open={isOpen}
        onClose={handleClose}
        PaperProps={{
          sx: {
            height: {
              xs: "85vh",
              sm: "80vh",
            },
            borderTopLeftRadius: 2,
            borderTopRightRadius: 2,
          },
        }}
      >
        <Box sx={{ p: 2, height: "100%", overflow: "auto" }}>
          <Stack spacing={2}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Header label="Page Manual" sx={{ textAlign: "left", my: 0 }} />
                <Typography variant="body2" color="text.secondary">
                  Current page: {location.pathname}
                </Typography>
              </Box>
              <IconButton onClick={handleClose} aria-label="Close manual drawer">
                <CloseIcon />
              </IconButton>
            </Box>
            <ManualContent
              route={location.pathname}
              introText="This panel shows manual content for the current page first, then the full manual library underneath."
            />
          </Stack>
        </Box>
      </Drawer>
    </>
  );
}
